import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";

import { getData } from "features/dinamic";


interface PromedioState {
    status: string;
    error: string;
    promedioList: any[],
    promedioListActive: any[],
    promedio: {
        idPromedio: number | null;
        nombre: string | null;
    }

}

const initialState: PromedioState = {
    status: 'idle',
    error: '',
    promedioList: [],
    promedioListActive: [],
    promedio: {
        idPromedio: null,
        nombre: null
    }
}

export const fetchPromedio = createAsyncThunk('fetchPromedio', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 45;
    const { result, message, data } = await getData({ idsp }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const fetchPromedioActive = createAsyncThunk('fetchPromedioActive', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 46;
    const { result, message, data } = await getData({ idsp }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});


export const promedioSlice = createSlice({
    name: 'promedio',
    initialState,
    reducers: {
        setPromedioList: (state, action) => {
            state.promedioList = action.payload;
        },
        setPromedioListActive: (state, action) => {
            state.promedioListActive = action.payload;
        },
        setPromedio: (state, action) => {
            state.promedio = !action.payload ? initialState.promedio : action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(fetchPromedio.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchPromedio.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.promedioList = data ? data : [];

            })
            .addCase(fetchPromedio.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
            .addCase(fetchPromedioActive.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchPromedioActive.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.promedioListActive = data ? data : [];

            })
            .addCase(fetchPromedioActive.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
    }
})

export const selectPromedioList = (state: RootState) => state.promedio.promedioList;
export const selectPromedioListActive = (state: RootState) => state.promedio.promedioListActive;
export const selectPromedio = (state: RootState) => state.promedio.promedio;

export const { setPromedioList, setPromedioListActive, setPromedio } = promedioSlice.actions;

export default promedioSlice.reducer;



